import React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { useAuth, ProvideAuth } from './store/auth'
import SignIn from './components/signin'
import Layout from './components/layout'
import Heatmap from './components/heatmap'
import Devices from './components/devices'
import DevicesList from './components/devices/_id'
import Reports from './components/reports'
import ReportsDetail from './components/reports/_id'
import BaseStations from './components/baseStations'
import BaseStationsDetail from './components/baseStations/_id'
import About from './components/about'
import Dashboard from './components/dashboard'
import Notifications from './components/notifications'
import NotificationsDetail from './components/notifications/_id'
import ViewNotifications from './components/viewNotifications'
import Incidents from './components/incidents'
import Geofencing from './components/geofencing'
import GeofencingDetail from './components/geofencing/_id'
import UseAppsKpi from './components/useAppsKpi'
import SearchKpis from './components/searchKpis'

import 'mapbox-gl/dist/mapbox-gl.css'
import './App.css'
import Tickets from './components/tickets'
import ForceRoaming from './components/forceRoaming'
import BaseStationsConnected from './components/baseStationsConnected'

const darkTheme = createMuiTheme({
    palette: {
        type: 'dark',
        primary: {
            light: '#33c9dc',
            main: '#00bcd4',
            dark: '#008394',
            contrastText: '#fff',
            background: '#0A232F',
        },
    },
})

export default function App() {
    return (
        <ThemeProvider theme={darkTheme}>
            <ProvideAuth>
                <Router>
                    <div>
                        <Switch>
                            <Route exact path={'/'}>
                                <RedirectionApp />
                            </Route>
                            <Route path="/login">
                                <SignIn />
                            </Route>
                            <PrivateRoute path="/main">
                                <div>Components here</div>
                            </PrivateRoute>
                            <PrivateRoute path="/heatmap">
                                <Heatmap />
                            </PrivateRoute>
                            <PrivateRoute exact path="/devices">
                                <Devices />
                            </PrivateRoute>
                            <PrivateRoute path="/devicesList/:id">
                                <DevicesList />
                            </PrivateRoute>
                            <PrivateRoute exact path="/base-stations">
                                <BaseStations />
                            </PrivateRoute>
                            <PrivateRoute exact path="/base-stations/create">
                                <BaseStationsDetail action="create" />
                            </PrivateRoute>
                            <PrivateRoute path="/base-stations/:id">
                                <BaseStationsDetail action="update" />
                            </PrivateRoute>
                            <PrivateRoute exact path="/search">
                                <SearchKpis />
                            </PrivateRoute>
                            <PrivateRoute exact path="/tickets">
                                <Tickets />
                            </PrivateRoute>
                            <PrivateRoute exact path="/forceRoaming">
                                <ForceRoaming />
                            </PrivateRoute>
                            <PrivateRoute exact path="/bsConnected">
                                <BaseStationsConnected />
                            </PrivateRoute>
                            <PrivateRoute exact path="/geofencing">
                                <Geofencing />
                            </PrivateRoute>
                            <PrivateRoute exact path="/geofencing/create">
                                <GeofencingDetail action="create" />
                            </PrivateRoute>
                            <PrivateRoute path="/geofencing/:id">
                                <GeofencingDetail action="update" />
                            </PrivateRoute>
                            <PrivateRoute exact path="/useapps">
                                <UseAppsKpi />
                            </PrivateRoute>
                            <PrivateRoute exact path="/notifications">
                                <Notifications />
                            </PrivateRoute>
                            <PrivateRoute exact path="/notifications/create">
                                <NotificationsDetail action="create" />
                            </PrivateRoute>
                            <PrivateRoute path="/notifications/:id">
                                <NotificationsDetail action="update" />
                            </PrivateRoute>
                            <PrivateRoute exact path="/viewnotifications">
                                <ViewNotifications />
                            </PrivateRoute>
                            <PrivateRoute exact path="/reports">
                                <Reports />
                            </PrivateRoute>
                            <PrivateRoute path="/reports/:id">
                                <ReportsDetail />
                            </PrivateRoute>
                            <PrivateRoute path="/about">
                                <About />
                            </PrivateRoute>
                            <PrivateRoute path="/dashboard">
                                <Dashboard />
                            </PrivateRoute>
                            <PrivateRoute path="/incidents">
                                <Incidents />
                            </PrivateRoute>
                        </Switch>
                    </div>
                </Router>
            </ProvideAuth>
        </ThemeProvider>
    )
}

// A wrapper for <Route> that redirect to the /login or /main route
// if you entered "/"" path
function RedirectionApp() {
    let auth = useAuth()
    return (
        <Route exact path={'/'}>
            {auth.user ? <Redirect to={'/heatmap'} /> : <Redirect to={'/login'} />}
        </Route>
    )
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({ children, ...rest }) {
    let auth = useAuth()
    return (
        <Route
            {...rest}
            render={({ location }) =>
                auth.user ? (
                    <Layout>{children}</Layout>
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    )
}
